// Content of: import { visuallyHidden } from '@mui/utils';
export const visuallyHiddenMixin = () => {
    return {
        border: '0px solid',
        clip: 'rect(0 0 0 0)',
        height: '1px',
        margin: '-8px',
        overflow: 'hidden',
        padding: '0px',
        position: 'absolute',
        whiteSpace: 'nowrap',
        width: '1px',
    } as const;
};
